$ = require 'jquery'

class Common
  applyStyles: ->
    $form = $('#aspnetForm')
    $table = $form.closest('table')
    $table.before $form
    $table.remove()

    console.log 'Получаю курс у.е.'
    $.getJSON '//www.tourtrans.ru/ajax/kurs?jsoncallback=?', (data) ->
      console.log 'data', data
      kurs = parseFloat(data)
      if kurs > 0
        kurs = kurs.toFixed(2)

        $('.currency').html('<b>Текущий курс:</b> 1 у.е. = ' + kurs + ' руб.')


module.exports = new Common